// Upstream: shadcn-ui/ui apps/v4/registry/new-york-v4/ui/alert.tsx + cosscom/coss apps/origin/registry/default/components/comp-269.tsx — MIT. Classes from @ahcut/ui/recipes (callout*).

import type { ComponentProps, ReactNode } from "react";
import {
  calloutClass,
  calloutIconClass,
  calloutTitleClass,
  type CalloutTone,
} from "@ahcut/ui/recipes";
import { cn } from "@/lib/cn";
import { Glyph, type GlyphName } from "./glyph";

export type AlertTone = CalloutTone;

const GLYPHS: Record<AlertTone, GlyphName> = {
  neutral: "info",
  ok: "success",
  warn: "warning",
  danger: "error",
};

export interface AlertProps extends Omit<ComponentProps<"div">, "title"> {
  tone?: AlertTone;
  /** Glyph override (ui/glyphs.ts); `false` renders the alert without an icon. */
  icon?: GlyphName | false;
  title?: ReactNode;
}

/** Inline callout (the web Callout's twin). No implicit role — pass role="alert" / role="status" where the content is live. */
export function Alert({ tone = "neutral", icon, title, className, children, ...rest }: AlertProps) {
  const glyph = icon === false ? null : (icon ?? GLYPHS[tone]);
  return (
    <div data-slot="alert" className={cn(calloutClass(tone), className)} {...rest}>
      {glyph && <Glyph name={glyph} className={calloutIconClass(tone)} />}
      <div className="flex min-w-0 flex-col gap-1">
        {title && <p className={calloutTitleClass}>{title}</p>}
        {children && <div>{children}</div>}
      </div>
    </div>
  );
}
